<template>
    <b-container fluid="" style="height: 100%">
      <div class="container">
          <b-row>
              <b-col>
              <b-navbar toggleable="lg" type="dark" variant="custom">
                  <b-navbar-brand>
                      <img :height="brandLogoHeight" :alt="brandAlt" :src="brandLogo">
                  </b-navbar-brand>

                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                  <b-collapse  id="nav-collapse" is-nav>
                      <b-navbar-nav class="ml-auto">

                          <b-nav-item-dropdown
                              :text="getCurrentLang()"
                              right
                          >
                              <b-dropdown-item
                                  v-for=" lang of langList"
                                  :key="lang.id"
                                  @click="updateLang(lang.id)"
                              >{{lang.name}}</b-dropdown-item>
                          </b-nav-item-dropdown>
                      </b-navbar-nav>
                  </b-collapse>
              </b-navbar>
              </b-col>
          </b-row>
          <b-row>
              <b-col>
              <b-form class="login mt-5" @submit.prevent="login">
                  <b-alert v-model="showErrorAlert" variant="danger" dismissible>
                      {{$t('login_or_password_are_incorrect')}}
                  </b-alert>

                  <b-row>
                      <b-col>
                          <b-form-input
                              :placeholder="$t('login_placeholder')"
                              v-model="username"
                              id="username"
                              data-placement="left"
                              title="login"
                          />
                      </b-col>
                      <b-col>
                          <b-form-input
                              :placeholder="$t('password_placeholder')"
                              v-model="password"
                              id="password"
                              data-placement="left"
                              type="password"
                              title="password"

                          />
                      </b-col>
                  </b-row>
                  <!--            <label>login</label>-->
                  <!--            <input required v-model="username" type="text" placeholder="Login"/>-->
                  <!--            <label>Password</label>-->
                  <!--            <input required v-model="password" type="password" placeholder="Password"/>-->
                  <hr/>

                  <b-button block type="submit" variant="primary">{{$t('login')}}</b-button>

              </b-form>
              </b-col>
          </b-row>
      </div>
    </b-container>
</template>

<script>
    import {loadLanguageAsync} from "@/client/i18n";
    import {localize} from "vee-validate";

    export default {
        name: "Login",
        data(){
            function getLangList() {
                const langsCongig = process.env.VUE_APP_LANGS.split(",");

                const langs = {
                    ru: {id: "ru", name: 'RU'},
                    en: {id: "en", name: 'EN'}
                };

                let data = [];

                langsCongig.forEach(
                    (lang) => {
                        data.push(langs[lang]);
                    }
                );

                return data
            }

            return {
                defaultLang: process.env.VUE_APP_DEFAULT_LANG,
                oldVersionLink: process.env.VUE_APP_OLD_VERSION_LINK,
                brandAlt: process.env.VUE_APP_NAME,
                brandLogo: 'assets/logo/' + process.env.VUE_APP_LOGO,
                brandLogoHeight: process.env.VUE_APP_LOGO_HEIGHT + 'px',
                showErrorAlert: false,
                username : "",
                password : "",
                langList: getLangList(),
            }
        },
        methods: {
          updateLang: function (value) {
            this.$store.commit('selLang', {lang: value})
            loadLanguageAsync(value)
            location.reload();
          },
          login: function () {
                let username = this.username
                let password = this.password
                this.$store.dispatch('login', { password, username })
                    .then(() => this.$router.push('/'))
                    .catch(
                        error => {
                            console.log(error)
                          if (error.response && error.response.status === 401) {
                            this.showErrorAlert = true;
                          } else {
                            this.$emit('load-error', error);
                          }
                        }
                    )

            },
          getCurrentLang: function() {
            for (let lng in this.langList) {
              if (this.langList[lng].id === this.lang) {
                return this.langList[lng].name
              }
            }

            return this.lang
          },
            getAppLink: function () {
                if (this.getCurrentLang() === 'RU') {
                    return process.env.VUE_APP_APP_LINK_RU;
                }

                return process.env.VUE_APP_APP_LINK_EN;
            },
            getUsbLink: function () {
                if (this.getCurrentLang() === 'RU') {
                    return process.env.VUE_APP_USB_LINK_RU;
                }

                return process.env.VUE_APP_USB_LINK_EN;
            }
        },
        computed: {
            lang : {
              get() {
                return this.$store.getters.getLang || this.defaultLang
              },
              set(value) {
                this.$store.commit('selLang', {lang: value})
                loadLanguageAsync(value)
                localize(value);
              }
            },
        }
    }
</script>

<style scoped>

</style>
